/* Beautify-inspired horizontal product tabs behavior. */
(function () {
  if (window.ckTabsLoaded) return;
  window.ckTabsLoaded = true;

  function initTabs(root) {
    var sections = root.matches && root.matches('[data-ck-tabs]')
      ? [root]
      : (root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll('[data-ck-tabs]')) : []);

    sections.forEach(function (section) {
      if (section.dataset.ckTabsInit === 'true') return;
      section.dataset.ckTabsInit = 'true';

      var toggles = Array.prototype.slice.call(section.querySelectorAll('.ck-tabs__toggle'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.ck-tabs__panel'));

      function activate(id) {
        toggles.forEach(function (t) {
          var active = t.dataset.target === id;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var active = p.id === id;
          p.classList.toggle('is-active', active);
          if (active) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      }

      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          activate(toggle.dataset.target);
        });
      });

      // Keyboard support: arrow keys move between tabs.
      toggles.forEach(function (toggle, i) {
        toggle.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = toggles[(i + 1) % toggles.length];
          if (event.key === 'ArrowLeft') next = toggles[(i - 1 + toggles.length) % toggles.length];
          if (next) {
            event.preventDefault();
            next.focus();
            activate(next.dataset.target);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTabs(document);
    });
  } else {
    initTabs(document);
  }

  // Theme editor: re-init on section load, and reveal the tab that owns a
  // selected block so merchants always see what they're editing.
  document.addEventListener('shopify:section:load', function (event) {
    initTabs(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest ? event.target.closest('[data-ck-tabs]') : null;
    if (!section) return;
    var panel = event.target.closest('.ck-tabs__panel');
    if (panel) {
      var toggle = section.querySelector('.ck-tabs__toggle[data-target="' + panel.id + '"]');
      if (toggle) toggle.click();
      return;
    }
    // Tab block: its shopify_attributes sit on the <li> in the tab bar,
    // which directly contains the toggle button.
    var tabToggle = event.target.querySelector ? event.target.querySelector('.ck-tabs__toggle') : null;
    if (tabToggle) tabToggle.click();
  });
})();
